import { Injectable } from '@angular/core';

@Injectable()
export class GlobalVariables {
    public dark = true;
    public prefersColor: MediaQueryList|any;

}
